module.exports = __webpack_public_path__ + "static/anna_marie-fe4572326ed95b2878ce8e90d8824f19.pdf";